module.exports = __webpack_public_path__ + "img/img_ico.5c4f09d9.png";